// Shared across every proposal: home preparation list (paid by the seller) and the net-sheet cost note.
// Edit here once; every client's page picks it up.

export const homePrep = {
  title: "Home preparation",
  note: "Paid by you, coordinated with help from my listing team",
  items: [
    "Pre-inspection and sewer scope",
    "Landscape tune-up",
    "Pressure wash hard surfaces",
    "Professional home cleaning",
    "If applicable: priority repairs; service furnaces, gas fireplaces and AC; paint, flooring, etc. (if needed)",
  ],
  icons: ["ClipboardCheck", "Trees", "Droplets", "SprayCan", "Wrench"],
};

// Shown under the list. Mentions typical net-sheet costs; proposals can override it via overrides.prepNote.
export const prepNote = "From your net sheet: pre-inspection and sewer scope $1,100, furnace service $300, pressure washing $600. Virtual staging is included.";
